// import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from 'stimulus-flatpickr'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

// you can also import a translation file
import { Icelandic } from "flatpickr/dist/l10n/is.js"

// flatpickr's own Icelandic locale capitalises months and weekdays the way
// English does - „Ágúst", „Sunnudagur". Icelandic does not, and is.yml has had
// them lowercase all along, so the pickers were the odd ones out. This is the
// very object flatpickr registered as `l10ns.is`, so lowering it here reaches
// every picker in the app.
const lowercased = (names) => names.map((name) => name.toLocaleLowerCase("is"))

Icelandic.months.longhand = lowercased(Icelandic.months.longhand)
Icelandic.months.shorthand = lowercased(Icelandic.months.shorthand)
Icelandic.weekdays.longhand = lowercased(Icelandic.weekdays.longhand)
Icelandic.weekdays.shorthand = lowercased(Icelandic.weekdays.shorthand)

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  initialize() {
    // sets your language (you can also set some global setting for all time pickers)
    this.config = {
      locale: document.querySelector("body").getAttribute("data-locale"),
      altInput: true,
      altFormat: "j. F Y",
      mode: "single",
    }

    // If we provide a data-enabled-dates attribute, we will only allow the user to select dates that are in this array
    if(this.element.dataset["enabledDates"] !== undefined)
    {
      this.config["enable"] = JSON.parse(this.element.dataset["enabledDates"])
    }

    if(this.element.dataset["mode"] === "month")
    {
      this.config["plugins"] = [
        new monthSelectPlugin({
          shorthand: true,
          dateFormat: "Y/m/d",
          altFormat: "F Y",
          theme: "light"
        })
      ]
    }

    this.connectCalendarIcon()
  }

  connectCalendarIcon() {
    // If we have a calendar icon, we want to open the calendar when the user clicks on it
    var calendarIcon = this.element.parentNode.querySelector(".input-group-text")
    if(calendarIcon !== null)
    {
      calendarIcon.addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()

        this.fp.open()
      })
    }
  }

  // all flatpickr hooks are available as callbacks in your Stimulus controller
  change(selectedDates, dateStr, instance) {
    if(instance.element.id === "from")
    {
      var to = document.querySelector("#to")._flatpickr;
      if(selectedDates[0] > to.selectedDates[0])
        to.setDate(selectedDates[0])
    }
    else if(instance.element.id === "to")
    {
      var from = document.querySelector("#from")._flatpickr;
      if(selectedDates[0] < from.selectedDates[0])
        from.setDate(selectedDates[0])
    }
  }
}